<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'

  export let start = 'top 70%'
  export let toggleActions = 'play play play pause'
  export let delay = 0
  export let fromY = 30
  export let duration = 0.5
  export let useChildren = false

  let self, tl, sc

  onMount(() => {
    tl = gsap.timeline()
    const params = {
      y: fromY,
      opacity: 0,
      duration,
      ease: 'power2.out',
    }
    if(useChildren) params.stagger = 0.1
    tl.from(
      useChildren ? self.children : self,
      params,
      delay
    )
    sc = ScrollTrigger.create({
      trigger: self,
      start,
      toggleActions,
      animation: tl
    })
  })

  onDestroy(() => {
    tl?.kill()
    sc?.kill()
  })
</script>
<div bind:this={self} class={$$props.class}>
  <slot></slot>
</div>
